import React from 'react';
import { themr } from 'react-css-themr';
import styles from './backToTop.scss';
import upArrow from '../../../assets/images/bttBtnArrow.svg';

const BackToTop = () => {
  let backToTop = document.getElementById('backToTop');

  // replace class if navigating away from page when BTT button is visible
  if (backToTop !== null && backToTop.classList.value === 'backToTop__backToTop___1Smks') {
    backToTop.classList.replace(styles.backToTop, styles.inactive);
  }

  // Variable used to toggle class once instead of every set interval,
  // fixes issue of constant event listening when user is at end of screen
  let visible = false;

  // BTT button toggle logic
  function toggleBackToTopBtn() {
    if (window.pageYOffset > screen.height) {
      if (!backToTop) backToTop = document.getElementById('backToTop');
      if (visible === false) {
        backToTop.classList.replace(styles.inactive, styles.backToTop);
      }
      visible = true;
    } else {
      if (visible === true) {
        backToTop.classList.replace(styles.backToTop, styles.inactive);
      }
      visible = false;
    }
  }

  // Minimize the frequency of checking if BTT button should be toggled
  let didScroll = false;
  function toggleDidScroll() {
    didScroll = true;
  }
  window.onscroll = toggleDidScroll;
  setInterval(() => {
    if (didScroll) {
      didScroll = false;
      toggleBackToTopBtn();
    }
  }, 100);

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  return (
    <div>
      <button
        id="backToTop"
        className={styles.inactive}
        onClick={scrollToTop}
      >
        <img className={styles.bttImage} src={upArrow} alt="Back To Top Button" />
      </button>
    </div>
  );
};

export default themr('BackToTop', styles)(BackToTop);



// WEBPACK FOOTER //
// ./client/app/shared/components/BackToTop/index.jsx